import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { IoEllipsisHorizontalSharp } from "react-icons/io5";
import { toast } from "react-toastify";
import { SettingsContext } from "../../../../../../contexts/Settings";
import { UserContext } from "../../../../../../contexts/User";
import {
  _t,
  checkPermission
} from "../../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

const POSCardDropdown = ({
  newOrder,
  setNoteRiderModal,
  setOrderDetails,
  handleSubmitOrder,
  buttonDisabled,
}) => {
  const [open, setOpen] = useState(false);
  const { loading } = useContext(SettingsContext);
  const { authUserInfo } = useContext(UserContext);
  const { t } = useTranslation();
  const { order_id } = useParams();
  const rootRef = useRef(null)

  // Close dropdown when clicking outside
  useEffect(() => {
    if (!open) return;

    const onDocMouseDown = (e) => {
      // if click is outside the dropdown root, close
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", onDocMouseDown);
    return () => {
      document.removeEventListener("mousedown", onDocMouseDown);
    };
  }, [open]);

  // Toggle without propagating click
  const toggleDropdown = (e) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  const handleAdvanceBooking = (e) =>{
    e.stopPropagation();
    setOpen(false);
    if(!newOrder || newOrder.length === 0){
      toast.error("Please select item first");
      return;
    }
    setOrderDetails((curr)=>({...curr, is_advance_booking: 1, pre_order_modal: true}))
  }

  return (
    <div ref={rootRef} className="position-relative d-inline-block">
      {/* Three Dots Button */}
      <button
        aria-expanded={open}
        onClick={toggleDropdown}
        className="btn btn-light py-0 px-1 border-0 card-dropdown-toggle"
        style={{ color: "#333 !important", }}
      >
        <IoEllipsisHorizontalSharp/>
      </button>

      {/* Custom Dropdown */}
      {open && (
        <div
          aria-hidden={!open}
          className="custom-dropdown shadow-sm p-2 rounded bg-white"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            title="Rider Note"
            disabled={buttonDisabled}
            className="btn btn-primary sm-text text-uppercase rounded-25 px-2 py-1 card-dropdown-button"
            onClick={(e) =>
              newOrder && newOrder.length > 0
                ? (
                  setOpen(false),
                  setNoteRiderModal(true)
                )
                : toast.error("Please select item first")
            }
          >
            <img src="/assets/img/writing.png" style={{maxHeight:"1.25rem"}} alt=""/>
          </button>
          {authUserInfo.permissions !== null &&
            checkPermission(
              authUserInfo.permissions,
              "Submit"
            ) && authUserInfo.details.user_type !== "call_center" ? (
              <>
                <button
                  disabled={buttonDisabled || order_id}
                  type="button"
                  className="ml-2 btn btn-danger sm-text text-uppercase rounded-25 btn-card-bottom font-weight-bold hover-effect card-dropdown-button"
                  onClick={(e) =>{
                    if(!loading){ 
                      setOpen(false);
                      handleSubmitOrder(e, 1)
                    }
                  }}
                >
                  {!loading ?
                    _t(t("hold"))
                    :  _t(t("Please wait"))}
                </button>
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "Advance Booking"
                  ) ? (
                    <div className="mt-2 mb-1">
                      <button
                        disabled={buttonDisabled || order_id}
                        type="button"
                        className="btn btn-success sm-text text-uppercase rounded-25 btn-card-bottom font-weight-bold card-dropdown-button"
                        onClick={(e) =>{
                          if(!loading){ 
                            handleAdvanceBooking(e);
                          }
                        }}
                        style={{fontSize: "0.69rem"}}
                      >
                        {!loading ?
                          _t(t("Advance Booking"))
                          :  _t(t("Please wait"))}
                      </button>
                    </div>
                    // <div className="d-flex justify-content-between align-items-center my-1 table-text font-weight-md">
                    //   <label htmlFor="adv_booking" className="form-check-label mb-0 mr-2">
                    //     Advance Booking
                    //   </label>
                    //   <input id="adv_booking" style={{marginTop: "0.1rem"}} checked={orderDetails.is_advance_booking} type="checkbox" className="form-check-input" onChange={(e) => handleAdvanceBooking(e)}/>
                    // </div>
                  ) : ""
                }
              </>
          ) : ""}    
        </div>
      )}

      {/* Inline Style (can move to CSS file) */}
      <style>{`
        .custom-dropdown {
          position: absolute;
          bottom: 115%; /* shows dropdown above */
          right: -1rem;
          min-width: 150px;
          z-index: 999;
        }
        .custom-dropdown::before {
          content: "";
          position: absolute;
          bottom: -5px;
          right: 10px;
          border-width: 6px;
          border-style: solid;
          border-color: white transparent transparent transparent;
        }
      `}</style>
    </div>
  );
};

export default POSCardDropdown;
